export const routes = (parentName) => {
  return [
    {
      path: "all-cost",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-AllCost`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-AllCost-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "special",
          name: `${parentName}-AllCost-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-AllCost-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: "new-special",
          name: `${parentName}-AllCost-New-Special`,
          component: () => import("./UpsertSpecial.vue"),
        },
        {
          path: ":id/edit/special",
          name: parentName + "-" + "AllCost-Edit-Special",
          component: () => import("./UpsertSpecial.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "AllCost-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "AllCost-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
